import * as React from "react";
import type { Settings, GameType, GameMode } from "../../core/types";
import { KUJIFUNZA } from "../../core/baogame";

type GameStage = "mtaji" | "namua";
export type ContextType = {
  gameType: GameType;
  gameStage: GameStage;
  gameMode: GameMode;
  settings: Settings;
  setGameType?: (gameType: GameType) => void;
  setGameStage?: (gameStage: GameStage) => void;
  setGameSettings?: (settings: Settings) => void;
};
export const defaultGameSettings: ContextType = {
  gameType: KUJIFUNZA,
  gameStage: "mtaji" as GameStage,
  gameMode: "single",
  settings: {
    playbackSpeed: 400,
    expertLevel: "expert",
    startingSide: 0,
    showHints: true
  }
};
const GameSettingsContext: React.Context<ContextType> = React.createContext<ContextType>(defaultGameSettings);
export default GameSettingsContext;
